import type { OidcConfig } from './oidc';

/**
 * Web app configuration (§6c). The API base URL is the one required runtime knob;
 * it defaults to the local NestJS API port. In production this points at the
 * deployed API behind the OAuth2 gateway.
 */
/**
 * Absolute API origin. A scheme-less `NEXT_PUBLIC_API_URL` (e.g. `api.example.com`) would
 * make `${API_URL}${path}` a RELATIVE URL and mangle every request, so force a scheme
 * (https for a bare host) and strip any trailing slash.
 */
function normalizeApiUrl(v: string): string {
  const s = v.trim();
  const abs = /^https?:\/\//i.test(s) ? s : `https://${s}`;
  return abs.replace(/\/+$/, '');
}
export const API_URL = normalizeApiUrl(process.env.NEXT_PUBLIC_API_URL ?? 'http://localhost:3001');

/**
 * OIDC config (browser side, §P7). When `NEXT_PUBLIC_OIDC_ISSUER` +
 * `NEXT_PUBLIC_OIDC_CLIENT_ID` are set, the sign-in gate runs the real
 * Authorization Code + PKCE flow; otherwise it falls back to the dev-token
 * bridge. `redirect_uri` defaults to the app origin. Returns null when OIDC is
 * not configured (dev/demo).
 */
export function oidcConfig(): OidcConfig | null {
  const issuer = process.env.NEXT_PUBLIC_OIDC_ISSUER?.trim();
  const clientId = process.env.NEXT_PUBLIC_OIDC_CLIENT_ID?.trim();
  if (!issuer || !clientId) return null;
  const redirectUri =
    process.env.NEXT_PUBLIC_OIDC_REDIRECT_URI?.trim() ||
    (typeof window !== 'undefined' ? `${window.location.origin}/` : '');
  return {
    issuer,
    clientId,
    redirectUri,
    scope: process.env.NEXT_PUBLIC_OIDC_SCOPE?.trim() || 'openid profile email',
    audience: process.env.NEXT_PUBLIC_OIDC_AUDIENCE?.trim() || undefined,
  };
}
